<div class="lds-wrap" *ngIf="router.url.indexOf('/auth/login') === -1">
	<div class="lds-dual-ring"></div>
</div>
<router-outlet></router-outlet>